import { API_REQUEST_TYPES } from "../../enums";
import { resetApi } from "../../services/axios";
import { API } from "../endpoints";

export function fetchTypeformQuestionsForVendorFeedback() {
  return async function (dispatch) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.GET,
        url: API.TYPEFORM.GET_TYPEFORM_QUESTIONS_FOR_VENDOR_FEEDBACK,
        config: {
          validateUser: false,
        },
      })
    );

    if (res.success) {
    }

    return res;
  };
}

export function submitTypeformQuestionsForVendorFeedback(payload) {
  return async function (dispatch) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.POST,
        url: API.TYPEFORM.SUBMIT_TYPEFORM_QUESTIONS_FOR_VENDOR_FEEDBACK,
        payload,
        config: {
          validateUser: false,
          notifyError: false,
        },
      })
    );

    if (res.success) {
    }

    return res;
  };
}

export function fetchTypeformQuestionsForVendorFeedbackStatus({
  ambassadorInvitationId,
  userID,
}) {
  return async function (dispatch) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.GET,
        url: API.TYPEFORM.GET_TYPEFORM_QUESTIONS_FOR_VENDOR_FEEDBACK_STATUS({
          ambassadorInvitationId,
          userID,
        }),
        config: {
          validateUser: false,
          notifyError: false,
        },
      })
    );

    if (res.success) {
    }

    return res;
  };
}

export function fetchReviewReportDetails(payload) {
  return async function (dispatch) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.GET,
        url: API.TYPEFORM.GET_REVIEW_REPORT_DETAILS_BY_CLIENT(payload.reportId),
        config: {
          notifyError: false,
        },
      })
    );

    if (res.success) {
    }

    return res;
  };
}
